/*@ngInject*/
const YesNoRadioController = function ($scope, $controller, formViewerConstant, formComponentUtil, formMediator, localization, xmlUtil) {

    this.radioValue = '';
    this.explainValue = '';
    this.showYesText = false;
    this.showNoText = false;
    this.yesPrompt = '';
    this.noPrompt = '';

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    localization.getTranslations().then((translations) => {
        this.translations = translations.formsViewer.yesNoRadio;
    });

    this.$onInit = function () {
        this.onInit();
        let uiField = this.fieldStructure.uiField,
            options = (uiField.options) ? xmlUtil.parseString(uiField.options) : null;

        this.showYesText = (options) ? options.showYesText : false;
        this.showNoText = (options) ? options.showNoText : false;
        this.yesPrompt = (options) ? options.yesText : this.translations.pleaseExplain;
        this.noPrompt = (options) ? options.noText : this.translations.pleaseExplain;

        this.yesLabel = (options) ? options.yesText : this.translations.yes;
        this.noLabel = (options) ? options.noText : this.translations.no;

        this.radioValue = this.splitFieldValue(0);
        if (this.radioValue === 'true') {
            this.radioValue = 'yes';
        } else if (this.radioValue === 'false') {
            this.radioValue = 'no';
        }
        this.buildToolTipMessage();
        this.explainValue = this.splitFieldValue(1);
        this.yesName = _.join([this.fieldStructure.uiField.fieldTemplate.formTemplateId, this.getComponentId(this.fieldStructure.uiField), this.fieldStructure.rowNumber, 'yes'], ' ');
        this.noName = _.join([this.fieldStructure.uiField.fieldTemplate.formTemplateId, this.getComponentId(this.fieldStructure.uiField), this.fieldStructure.rowNumber, 'no'], ' ');
    };

    this.$onChanges = function () {
        this.onChanges();
        this.radioValue = this.splitFieldValue(0);
        if (this.radioValue === 'true') {
            this.radioValue = 'yes';
        } else if (this.radioValue === 'false') {
            this.radioValue = 'no';
        }
        this.explainValue = this.splitFieldValue(1);
        this.buildToolTipMessage();
    };

        this.getComponentContainerWidth = function () {
            var isRowRepeater = this.fieldStructure.isRowRepeaterField,
                rowRepeaterColumnHeaderExtraWidth = 15,
                isLabelTopAligned = !this.fieldStructure.layout.isLabelLeftAligned,
                inputContainerWidth = 150,
                topAlignmentExtraWidth = 0,
                extraWidth = isLabelTopAligned ? topAlignmentExtraWidth : inputContainerWidth,
                labelWidth = this.getLabelWidth(),
                result;

            if(!isRowRepeater && this.fieldStructure.requiredIndicatorLabelConfig.width === 0) {
                return labelWidth;
            }
            if(isRowRepeater) {
                result = labelWidth > inputContainerWidth ? labelWidth : inputContainerWidth;
                result += rowRepeaterColumnHeaderExtraWidth;
            }
            else if (isLabelTopAligned) {
                result = labelWidth > inputContainerWidth ? labelWidth : inputContainerWidth;
            }
            else {
                result = labelWidth + extraWidth;
            }

            return result;
        };

        this.getLabelWidth = function () {
            var isRowRepeater = this.fieldStructure.isRowRepeaterField,
                defaultLabelWidth = 150;
            if(!isRowRepeater && this.fieldStructure.requiredIndicatorLabelConfig.width === 0) {
                return '100%';
            } else {
                return this.fieldStructure.requiredIndicatorLabelConfig.width;
            }
        };

    this.showTextArea = function () {
        return (this.radioValue === 'yes' && this.showYesText) || (this.radioValue === 'no' && this.showNoText);
    };

    this.splitFieldValue = function (index) {
        if (!this.fieldStructure.fieldModel) {
            return '';
        }

        let radioValueArray = _.split(this.fieldStructure.fieldModel.value, '::');
        return radioValueArray[index] || '';
    };

    this.concatFieldValue = function () {
        if (this.explainValue !== '') {
            return this.radioValue + '::' + this.explainValue;
        } else {
            this.explainValue = '';
            return this.radioValue;
        }
    };

    this.handleLabelClick = function (event, radioValue) {
        if (this.fieldStructure.dynamicProperties.disabled) {
            return;
        }

        if (event.ctrlKey) {
            this.radioValue = null;
        } else {
            this.radioValue = radioValue;
        }

            this.handleClick();
        };

        this.handleClick = function () {
            this.explainValue = '';
            this.handleChange();
            this.handleBlur();
        };

    this.onClick = function (event) {
        if (this.fieldStructure.dynamicProperties.disabled) {
            return;
        }

        if (event && event.ctrlKey) {
            this.radioValue = null;
            this.handleClick();
        }
    };

    this.handleChange = function () {
        this.fieldStructure.hasLocalChanges = true;

        if (this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel.value = this.concatFieldValue();
        } else {
            this.fieldStructure.fieldModel = {value: this.concatFieldValue()};
        }
    };

    this.handleBlur = function () {
        if (this.fieldStructure.hasLocalChanges) {
            formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
        }
    };

    this.buildToolTipMessage = function () {
        let prompt;
        if (this.radioValue === 'yes' && this.yesPrompt) {
            prompt = this.yesPrompt;
        } else if (this.radioValue === 'no' && this.noPrompt) {
            prompt = this.noPrompt;
        }
        if(prompt){
            this.fieldStructure.dynamicProperties.tooltip.message = _.replace(this.fieldStructure.dynamicProperties.tooltip.message, '{0}', _.replace(prompt, /:$/, ''));
        }
    }
};

angular.module('umFormViewer')
    .controller('yesNoRadioController', YesNoRadioController);
